<router-outlet></router-outlet>
<pms-network-status></pms-network-status>
